import { NextRouter, useRouter } from 'next/router';
import { Dispatch, useCallback, useEffect, useReducer, useRef } from 'react';

import {
  DynamicLessonAction,
  DynamicLessonReducer,
  DynamicLessonState,
} from './useCreateLessonState';

export type MiddlewareFn = (
  action: DynamicLessonAction,
  state: DynamicLessonState,
  router: NextRouter,
) => void;

export const useReducerWithMiddlewareDynamicLesson = (
  reducer: typeof DynamicLessonReducer,
  initialState: DynamicLessonState,
  middlewareFns: MiddlewareFn[],
  afterwareFns: MiddlewareFn[],
): [DynamicLessonState, Dispatch<DynamicLessonAction>] => {
  const [state, dispatch] = useReducer(reducer, initialState, undefined);
  const router = useRouter();
  const aRef = useRef<DynamicLessonAction | null>();

  const dispatchWithMiddleware: Dispatch<DynamicLessonAction> = useCallback(
    (action: DynamicLessonAction) => {
      middlewareFns.forEach(middlewareFn => middlewareFn(action, state, router));

      aRef.current = action;

      dispatch(action);
    },
    [middlewareFns, state, router],
  );

  useEffect(() => {
    if (!aRef.current) return;
    afterwareFns.forEach(afterwareFn => {
      if (!!!aRef.current) return;
      afterwareFn(aRef.current, state, router);
    });

    aRef.current = null;
  }, [afterwareFns, state, router]);

  return [state, dispatchWithMiddleware];
};
